import 'styles/global.css';
import ConnectedSystemsWeb from 'features/integrations/features/ConnectedSystems/index.web';
import SearchBar from 'components/SearchBar/SearchBar';

export default function ConnectedSystems() {
  return (
    <div className="d-flex flex-column gap-3 pt-3 h-100">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between flex-shrink-0">
        <div className="fs-4 fw-bold">Connected Systems</div>
        <SearchBar className="w-auto" />
      </div>
      {/* Content */}
      <div className="flex-grow-1 overflow-auto min-h-0">
        <ConnectedSystemsWeb />
      </div>
    </div>
  );
}
